import type { MonthSummary, SavingsGoal, Question } from "./types";

export const formatMoney = (value: number) =>
  new Intl.NumberFormat("en-IE", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(value);

export const MONTHS: MonthSummary[] = [
  {
    name: "August 2026",
    shortName: "Aug",
    income: 6100,
    expenses: 4125,
    categories: [
      { name: "Home", amount: 1650 },
      { name: "Everyday living", amount: 895 },
      { name: "Transport", amount: 305 },
      { name: "Leisure", amount: 475 },
      { name: "Other", amount: 800 },
    ],
  },
  {
    name: "September 2026",
    shortName: "Sep",
    income: 6200,
    expenses: 4470,
    categories: [
      { name: "Home", amount: 1650 },
      { name: "Everyday living", amount: 1120 },
      { name: "Transport", amount: 390 },
      { name: "Leisure", amount: 610 },
      { name: "Other", amount: 700 },
    ],
  },
  {
    name: "October 2026",
    shortName: "Oct",
    income: 6480,
    expenses: 4310,
    categories: [
      { name: "Home", amount: 1650 },
      { name: "Everyday living", amount: 980 },
      { name: "Transport", amount: 340 },
      { name: "Leisure", amount: 540 },
      { name: "Other", amount: 800 },
    ],
  },
];

export const GOALS: SavingsGoal[] = [
  {
    name: "Emergency fund",
    saved: 8600,
    target: 10000,
    note: "A little more breathing room, one contribution at a time.",
  },
  {
    name: "A place of our own",
    saved: 6000,
    target: 15000,
    note: "A future home, with your progress in clear view.",
  },
];

export const QUESTIONS: Question[] = [
  {
    id: "worth",
    label: "What am I worth?",
    explanation: "One account is only part of the story.",
    detail:
      "See your cash, savings, investments, and debts together. Know what makes up the total, including what you owe.",
  },
  {
    id: "spending",
    label: "Where is my money going?",
    explanation: "Make sense of the month.",
    detail:
      "See what came in, what went out, and the categories behind your spending. Change the month to explore the example.",
  },
  {
    id: "progress",
    label: "Am I making progress?",
    explanation: "Give your savings a purpose.",
    detail:
      "Track what you’ve set aside against a goal, and see how far you have left to go. Your goals, at your pace.",
  },
];

export const HEADER_LINKS = [
  { label: "Explore the questions", href: "#question-explorer" },
  { label: "Getting started", href: "#getting-started" },
];

export const SIGN_IN_HREF = "/login";
export const CREATE_ACCOUNT_HREF = "/register";
export const PAGE_TITLE = "Net Worth Tracker: Know where you stand";
